
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.746 19.759a.811.811 0 01-.081-1.072l.08-.092L14.474 12 7.746 5.405a.811.811 0 01-.081-1.072l.08-.092a.852.852 0 011.094-.08l.094.08 7.321 7.177c.298.292.325.75.081 1.072l-.08.092-7.322 7.177a.851.851 0 01-1.187 0z","fill":"#FCFDFF"}})])
          )
        }
      }
    